import { ROUTES } from "src/constants/ROUTES";
import s from "./styles.module.sass";
import CustomLink from "../../UI/CustomLink";
import { useEffect } from "react";
import { useWebAnalyticsContext } from "@shared/analytics/webAnalytics.contexts";

export const Page404View = () => {
	const linkText = "Перейти на главную страницу".toUpperCase();
	const { reachGoal } = useWebAnalyticsContext();

	useEffect(() => {
		reachGoal("404");
	}, []);

	return (
		<div className={s.wrapper}>
			<div className={s.container}>
				<h1 className={s.h1}>404</h1>
				<p className={s.title}>Такой страницы не существует...</p>

				<CustomLink href={ROUTES.MAIN} text={linkText} />
			</div>
		</div>
	);
};
